// @flow

import React, { Fragment } from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import moment from 'moment'
import Path from 'routes/path'
import Button from 'components/atoms/Button'
import Icon from 'components/atoms/Icon'
import PartsContainer from 'components/molecules/PartsContainer'
import LinkText from 'components/atoms/LinkText'
import SMConst from 'frontend_core/dist/constants/sm-const'
import ReservationModel from 'frontend_core/dist/model/Reservation'
import { mediaMax, mediaMin } from 'frontend_core/dist/styles/media'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import Colors from 'components/styles/colors'

const StatusDesc = styled.pre`
  color: ${Colors.gray9};
  margin-top: ${spacing.small_2}px;
  font-size: ${fontSize.small_2}px;
  text-align: center;
  line-height: 1.454;
  white-space: pre-wrap;
`
const StatusText = styled.pre`
  color: ${Colors.black};
  margin-top: ${spacing.small_2}px;
  font-size: ${fontSize.small}px;
  text-align: center;
  line-height: 1.454;
  white-space: pre-wrap;
`
const LabelHeader = styled.pre`
  font-size: ${fontSize.small_3}px;
  line-height: 1.2;
  font-weight: bold;
  text-align: center;
`
const ButtonWrapper = styled.div`
  margin-top: ${spacing.small_3}px;
  text-align: center;
`

type PropTypes = {
  status: string,
  refundAmount?: ?string,
  onClickChangeRequestFromUser: Function,
  onClickChangeRequestFromOwner: Function,
  onClickSelectPayment: Function,
}

function getGuideText(props: PropTypes) {
  switch (props.status) {
    // 予約変更リクエスト
    case 'hasChangeRequest':
      return {
        title: i18n.t('page.dashboard.inbox.reservationRequestGuide'),
        desc: i18n.t('page.dashboard.inbox.reservationRequestDesc'),
        buttonText: i18n.t('page.dashboard.inbox.confirmChangeReservation'),
        onClick: props.onClickChangeRequestFromUser,
      }
    // ホストからの予約変更
    case 'hasChangeRequestFromHost':
      return {
        title: i18n.t('page.dashboard.inbox.reservationRequestFromHostGuide'),
        desc: i18n.t('page.dashboard.inbox.reservationRequestFromHostDesc'),
        buttonText: i18n.t(
          'page.dashboard.inbox.confirmChangeReservationFromHost',
        ),
        onClick: props.onClickChangeRequestFromOwner,
      }
    // お問い合わせを予約変更リクエストに変更
    case 'hasChangeRequestInquiry':
      return {
        title: i18n.t('page.dashboard.inbox.changeRequestInquiryGuide'),
        desc: i18n.t('page.dashboard.inbox.changeRequestInquiryDesc'),
        buttonText: i18n.t('page.dashboard.inbox.confirmChangeRequestInquiry'),
        onClick: props.onClickSelectPayment,
      }
    // ゲストキャンセル:払い戻し
    case 'hasGuestCancelRefund':
      return {
        title: i18n.t('page.dashboard.inbox.refundedFromHostGuide'),
        text:
          i18n.t('page.dashboard.inbox.refundAmount') +
          (props.refundAmount || ''),
      }
    default:
      return {
        title: '',
        desc: '',
        buttonText: '',
      }
  }
}

export default function ReservationHostActionBlock(props: PropTypes) {
  const guideText = getGuideText(props)
  return (
    <Fragment>
      <LabelHeader>{guideText.title}</LabelHeader>
      {guideText.desc && <StatusDesc>{guideText.desc}</StatusDesc>}
      {guideText.text && <StatusText>{guideText.text}</StatusText>}
      {guideText.buttonText && (
        <ButtonWrapper>
          <Button
            tag="anchor"
            buttonType="medium"
            fullWidthSp
            colorType="blue"
            href={'#'}
            onClick={guideText.onClick}
          >
            {guideText.buttonText}
          </Button>
        </ButtonWrapper>
      )}
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationHostActionBlock/index.jsx